import React from 'react';
import { Bot } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface WelcomeScreenProps {
  onSend: (text: string) => void;
  disabled: boolean;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onSend, disabled }) => {
  const { t } = useLanguage();

  const questions = [
    { icon: '📊', text: t('chatbot.welcome.q1') },
    { icon: '📈', text: t('chatbot.welcome.q2') },
    { icon: '⚖️', text: t('chatbot.welcome.q3') },
    { icon: '💰', text: t('chatbot.welcome.q4') },
  ];

  return (
    <div className="flex flex-col items-center justify-center text-center px-2 pt-6 pb-2">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <Bot className="h-7 w-7 text-primary" />
      </div>
      <h4 className="text-sm font-semibold text-foreground mb-1">{t('chatbot.welcome.title')}</h4>
      <p className="text-xs text-muted-foreground mb-6 max-w-[240px] leading-relaxed">
        {t('chatbot.welcome.description')}
      </p>
      <div className="flex flex-col gap-2 w-full">
        {questions.map((q, i) => (
          <button
            key={i}
            onClick={() => onSend(q.text)}
            disabled={disabled}
            className="flex items-center gap-2.5 text-left text-xs px-3 py-2.5 rounded-xl
              border border-border bg-card hover:bg-muted/60
              transition-colors duration-150 text-foreground
              disabled:opacity-50 disabled:pointer-events-none
              active:scale-[0.98]"
          >
            <span className="text-base leading-none flex-shrink-0">{q.icon}</span>
            <span className="leading-snug">{q.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default WelcomeScreen;
